import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../app/slices/TrainingLocalizationSlice";
import useBufferedTextCommit from "../../../hooks/useBufferedTextCommit";
import "./PiQuizTextfield.css";

interface PiQuizTextfieldProps {
  value: string;
  onChange: (e: string, shortcode?: string) => void;
}

export default function PiQuizTextfield(props: PiQuizTextfieldProps) {
  const { value, onChange } = { ...props };
  const currLang = useSelector(selectCurrentLanguage);
  const { currentValue, handleValueChange, flushPendingValue } =
    useBufferedTextCommit({
      value,
      onCommit: (nextValue) => onChange(nextValue, currLang.shortcode),
      debounceMs: 500,
      flushOnCleanupKeys: [currLang.shortcode],
    });

  return (
    <input
      aria-label="piquiztextfield-input"
      className="piquiztextfield-root"
      value={currentValue}
      placeholder={"Answer"}
      onBlur={flushPendingValue}
      onChange={(e) => handleValueChange(e.target.value)}
    />
  );
}
